import illustration from '../../../../shared/assets/empty-illustration.svg'
import { Link } from 'react-router-dom'
import React from 'react'
import { StubContactLinks } from '../../../../lib/widgets/stubs/StubContactLinks'

interface TabNewStubProps {
  project?: string
}

export const TabNewStub = ({ project }: TabNewStubProps) => {
  return (
    <div className={'flex justify-center'}>
      <div className={'flex w-full max-w-[320px] flex-col items-center gap-[24px]'}>
        <div className={'w-full'}>
          <img alt={'Illustration'} className={'mx-auto max-w-full'} src={illustration} />
        </div>
        <div className={'flex w-full flex-col gap-[16px]'}>
          <div className={'flex flex-col items-center'}>
            <h2 className={'text-center text-[24px]'}>No data</h2>
            <p className={'text-center text-[15px] text-[#8E7CA7]'}>
              There are two likely reasons:
            </p>
          </div>
          <div
            className={'flex w-full flex-col gap-[16px] rounded-[16px] bg-focus/[0.06] p-[16px]'}
          >
            <ul className={'list list-disc pl-[16px] text-left text-focus-500'}>
              <li className={'pb-[12px]'}>
                There are no violations for the monitored{' '}
                <Link className={'text-default'} to={`/projects/${project}/keywords`}>
                  keywords
                </Link>{' '}
                and{' '}
                <Link className={'text-default'} to={`/projects/${project}/locations`}>
                  countries
                </Link>
              </li>
              <li>
                <Link className={'text-default'} to={`/projects/${project}/affiliate-tracking`}>
                  Affiliate tracking
                </Link>{' '}
                is set up incorrectly
              </li>
            </ul>
          </div>
          <div className={'flex flex-col items-center justify-center gap-[8px]'}>
            <p className={'max-w-[254px] text-center text-[13px] leading-[18px] text-[#8E7CA7]'}>
              Make sure to use an active tracking link and map the parameters correctly
            </p>
            <div className={'rounded-[16px] bg-focus/[0.06] p-[16px]'}>
              <p>
                brand.com/?
                <span className={'bg-[#A059FF]/[0.08] text-default'}>
                  utm_campaign=affiliate_id
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className={'flex flex-col gap-[8px]'}>
          <p className={'text-center text-[15px] text-[#8E7CA7]'}>Contact us for help</p>
          <StubContactLinks />
        </div>
      </div>
    </div>
  )
}
